import { useMutation } from 'data-fetching-client';
import { CREATE_ASSET_SYNC_TASK, CREATE_ASSET_SYNC_TASK_V3 } from '../../data/queries';
import { captureException } from '../../utils/captureException';
import { userInfoSync } from 'hub-http/userInfo';
import { SECURITY_ANNOTATION_MIGRATION_GATE } from '../../constants/gates';
import { useMemo } from 'react';
export function useCreateSyncTask(options = {}) {
  const {
    gates
  } = userInfoSync();
  const isUngatedForSecurityAnnotationMigration = useMemo(() => gates === null || gates === void 0 ? void 0 : gates.includes(SECURITY_ANNOTATION_MIGRATION_GATE), [gates]);
  const [mutateV1, mutateOptionsV1] = useMutation(CREATE_ASSET_SYNC_TASK, Object.assign({}, options, {
    onError: error => {
      var _options$onError;
      captureException(error, ['useCreateSyncTask']);
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
    }
  }));
  const [mutateV3, mutateOptionsV3] = useMutation(CREATE_ASSET_SYNC_TASK_V3, Object.assign({}, options, {
    onError: error => {
      var _options$onError2;
      captureException(error, ['useCreateSyncTask']);
      (_options$onError2 = options.onError) === null || _options$onError2 === void 0 || _options$onError2.call(options, error);
    }
  }));
  return isUngatedForSecurityAnnotationMigration ? Object.assign({
    mutate: mutateV3
  }, mutateOptionsV3) : Object.assign({
    mutate: mutateV1
  }, mutateOptionsV1);
}